import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { api } from '@app/utils/api';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { ISelectOption } from '@widgets/multi-select';
import { ERR_BAD_REQUEST } from '@app/contstants/http-codes';
import { ServerError } from '@app/error/ServerError';

export const fetch = async ({
  name,
  managers,
  source,
  tag,
  region,
  terms,
}: {
  name: string | null;
  managers: ISelectOption[];
  source: ISelectOption | null;
  tag: ISelectOption | null;
  region?: ISelectOption | null;
  terms?: number | null;
  // @ts-ignore
}): Promise<ISelectOption> => {
  try {
    const res = await api.post<{ id: string; name: string }>(
      `${PANEl_BASE_URL}/clients/clients/create_client/`,
      {
        name,
        managers: managers ? managers.map(manager => manager.value) : null,
        tag: tag?.value,
        region: region?.value,
        source: source?.value,
        terms,
      }
    );

    return { value: res.data.id, label: res.data.name };
  } catch (e: any) {
    if (e.status === ERR_BAD_REQUEST) {
      throw new ServerError(e.response.data.error);
    }
  }
};

export const useCreateCustomer = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
